import { motion } from "framer-motion";
import ChapterHeader from "@/components/landing/ChapterHeader";
import { useLang } from "@/lib/i18n";

const STAT_VALUES = ["35", "50+", "48h"];

export default function Storia() {
  const { t } = useLang();
  return (
    <section id="storia" data-testid="storia-section" className="mx-auto max-w-7xl px-5 py-28 sm:px-8 sm:py-36">
      <ChapterHeader number="01" title={t.storia.title} subtitle={t.storia.subtitle} />
      <div className="grid gap-14 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <div className="lg:sticky lg:top-28">
            <motion.div
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.8 }}
              className="relative overflow-hidden rounded-3xl border border-bordeaux/15 shadow-[0_30px_70px_-40px_rgba(171,24,43,0.5)]"
            >
              <div className="texture-toile absolute inset-0" aria-hidden="true" />
              <div className="absolute inset-0 bg-bordeaux/70" aria-hidden="true" />
              <blockquote className="relative p-8 font-display text-3xl font-medium italic leading-snug text-ivory sm:p-10 sm:text-4xl">
                &ldquo;{t.storia.quote}&rdquo;
                <span className="mt-6 block font-mono-alt text-xs not-italic font-bold uppercase tracking-[0.3em] text-gold">
                  {t.storia.motto}
                </span>
              </blockquote>
            </motion.div>
            <motion.div
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.8, delay: 0.15 }}
              className="mt-12 grid grid-cols-3 gap-6"
            >
              {STAT_VALUES.map((v, i) => (
                <div key={v}>
                  <p className="font-display text-4xl font-semibold text-bordeaux sm:text-5xl">{v}</p>
                  <p className="mt-1 font-mono-alt text-[10px] uppercase tracking-[0.22em] text-stone-500">
                    {t.storia.stats[i]}
                  </p>
                </div>
              ))}
            </motion.div>
          </div>
        </div>

        <div className="lg:col-span-7">
          <div className="relative border-l border-bordeaux/20 pl-8 sm:pl-12">
            {t.storia.timeline.map((tl, i) => (
              <motion.div
                key={`${tl.year}-${i}`}
                data-testid={`storia-timeline-${i}`}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.8, delay: i * 0.05, ease: [0.22, 1, 0.36, 1] }}
                className="relative pb-14 last:pb-0"
              >
                <span className="absolute -left-[38px] top-2 h-3 w-3 rounded-full border-2 border-bordeaux bg-[#FDFBF7] sm:-left-[54px]" />
                <p className="font-mono-alt text-xs uppercase tracking-[0.3em] text-bordeaux">{tl.year}</p>
                <h3 className="mt-2 font-display text-2xl font-semibold text-ink sm:text-3xl">{tl.title}</h3>
                <p className="mt-3 text-base leading-relaxed text-stone-600">{tl.text}</p>
              </motion.div>
            ))}
          </div>
          <motion.p
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="mt-6 border-l border-bordeaux/20 pl-8 font-display text-xl italic leading-snug text-bordeaux-dark sm:pl-12 sm:text-2xl"
          >
            {t.storia.closing}
          </motion.p>
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.8, delay: 0.1 }}
            className="arch-frame ml-8 mt-10 aspect-[4/5] overflow-hidden border border-bordeaux/10 sm:ml-12 sm:aspect-[3/4]"
          >
            <img
              src={require("@/assets/locale.jpg")}
              alt="L'interno della Gelateria Imperiale con i tavolini"
              className="h-full w-full object-cover transition-transform duration-700 hover:scale-105"
            />
          </motion.div>
        </div>
      </div>
    </section>
  );
}
